import React from 'react';

const CONFIG = {
  'Home Run': { label: 'HR', bg: 'bg-[#c4333e]', text: 'text-white', border: 'border-[#c4333e]' },
  'Triple':   { label: '3B', bg: 'bg-[#d8ceb3]', text: 'text-[#1e3a29]', border: 'border-[#d8ceb3]' },
  'Double':   { label: '2B', bg: 'bg-[#386646]', text: 'text-[#d8ceb3]', border: 'border-[#a9c9b1]' },
  'Single':   { label: '1B', bg: 'bg-transparent', text: 'text-[#a9c9b1]', border: 'border-[#658d71]' },
};

const HitEventBadge = ({ event, size = 'md' }) => {
  const cfg = CONFIG[event] || CONFIG['Single'];
  const sizeClass = size === 'sm' ? 'text-[8px] px-1.5 py-0.5' : 'text-[10px] px-2 py-0.5';
  return (
    <span className={`font-black uppercase tracking-widest border ${cfg.bg} ${cfg.text} ${cfg.border} ${sizeClass} shrink-0`}>
      {cfg.label}
    </span>
  );
};

export default HitEventBadge;